import styled, { css } from "styled-components/macro";
import { rgba } from "polished";

import { Link, NavLink } from "react-router-dom";

import { colors, fontStyle, space } from "shared/styles/constants";
import { hoverFocus, getStatus } from "shared/styles/defaults";
import { IStatus } from "shared/types";

export interface StyledLinkProps {
  status?: IStatus;
  muted?: boolean;
}

export const LinkStyles = () => css`
  display: inline;
  align-items: center;

  ${fontStyle.medium}
  color: ${({ muted, status }: StyledLinkProps) =>
    muted ? colors.grey4 : getStatus(status).textColor};

  text-align: left;

  > * + * {
    margin-left: ${space.xxs};
  }

  > span {
    ${({ status }: StyledLinkProps) =>
      `background-image: linear-gradient(
        ${rgba(getStatus(status).bgColor, 0.25)},
        ${rgba(getStatus(status).bgColor, 0.25)}
        );
      `}

    background-position: 0% 100%;
    background-repeat: no-repeat;
    background-size: 100% 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:hover {
    > span {
      ${({ status }: StyledLinkProps) =>
        `background-image: linear-gradient(
        ${getStatus(status).bgColor},
        ${getStatus(status).bgColor}
        );
      `}
    }
  }

  ${hoverFocus.defaultFocus}
`;

export const FancyFakeLink = styled.span<StyledLinkProps>`
  ${LinkStyles}
`;

export const StyledAnchor = styled.a<StyledLinkProps>`
  ${LinkStyles}

  text-decoration: none;
`;

export const StyledButtonLink = styled.button<StyledLinkProps>`
  ${LinkStyles}
`;

export const StyledLink = styled(Link)<StyledLinkProps>`
  ${LinkStyles}

  text-decoration: none;
`;

export const StyledNavLink = styled(NavLink)<StyledLinkProps>`
  ${LinkStyles}

  > span {
    display: flex;
    align-items: center;
  }

  &.active {
    > span {
      background-size: 100% 2px;
    }
  }

  text-decoration: none;
`;
